module.exports = __webpack_public_path__ + "fonts/Alibaba-PuHuiTi-Heavy.c3a51600.ttf";